import { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import { RenameVersionDialog } from "./RenameVersionDialog";

export const EditVersionNameButton: FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span
        className="text-blue-600 hover:text-blue-600 cursor-pointer hover:underline text-sm font-medium"
        onClick={() => setOpen(true)}
      >
        <FormattedMessage id="editVersion" defaultMessage="Rename Version" />
      </span>
      {open && <RenameVersionDialog open={open} setOpen={setOpen} />}
    </>
  );
};
